export default {
  functionKey: "ESTNUM",
  title: "ESTNUM",
  group: "Organisation",
  origin: [],
  target: [],
  description: "Retourne true si la valeur est un nombre.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = !isNaN(parseFloat(${origin})) && isFinite(${origin});`;
    return { displayCode: code, safeCode: code };
  }
}
